module.exports = __webpack_public_path__ + "media/images/planning_a_trip_to_japan/zh-hans/4/4-f2fcd1b718f22af9fcd964ca0b5347ab.jpg";